export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },

    setShowAppointments({commit}) {
        commit('showAppointments')
    },

    setShowAttendanceTable({commit}, data) {
        commit('showAttendanceTable', data)
    }
}
